@if ({ isLoggingIn: isLoggingInWithNtd$ | async }; as STATE) {
  <form class="form" (ngSubmit)="onSubmit()">
    <div class="form__group">
      <label for="organizationNtd" class="form__label"
        >NTD (Numéro de Télédéclarant)
        <span class="form__label--required">*</span>
      </label>
      <div class="form__item form__item--with-prefix">
        <span class="form__prefix">
          <mat-icon svgIcon="dgi-list" color="primary"></mat-icon>
        </span>
        <input
          type="text"
          id="organizationNtd"
          [formControl]="organizationNtd"
          class="form__input"
          placeholder="Ex. 12345678923432"
        />
      </div>

      @if (organizationNtd.hasError('required') && organizationNtd.touched) {
        <mat-error
          [innerHtml]="'Ce champ est requis'"
          class="form__error-red"
        ></mat-error>
      }

      @if (organizationNtd.hasError('minlength') && organizationNtd.touched) {
        <mat-error
          [innerHtml]="'Le NTD doit contenir au moins 8 caractères'"
          class="form__error-red"
        ></mat-error>
      }
    </div>

    <div class="form__actions">
      <button
        type="submit"
        button
        [disabled]="!!STATE.isLoggingIn || organizationNtd.invalid"
        [loading]="!!STATE.isLoggingIn"
        [fullWidth]="true"
      >
        Accéder à l’entreprise
      </button>

      <p class="form__actions--text">
        Voulez-vous retourner à l'accueil ?
        <span>
          <a [routerLink]="routes.login" class="form__actions--link"
            >Se connecter</a
          >
        </span>
      </p>
    </div>
  </form>
}
